
import { Component, Vue } from 'vue-property-decorator'
import { NavBar, BreadCrumb } from '@/components'
import FetchWrapper from '@/classes/fetchWrapper'

Vue.prototype.$multiwatch = function (props, watcher) {
  var iterator = function (prop) {
    this.$watch(prop, watcher)
  }
  props.forEach(iterator, this)
}

@Component({
  components: {
    NavBar,
    BreadCrumb
  }
})
export default class VideoView extends Vue {
  data () {
    return this.getResetData()
  }

  getResetData () {
    return {
      text: '',
      lines: [],
      line: [],
      expressions: [],
      activeLine: 0,
      // playerInterval: null,
      artefato: null,
      articleResults: [],
      articleChosenIndex: null,
      isLoading: false,
      isPlaying: false,
      player: null,
      youtubeLoadDone: false,
      videoId: null,
      ytbId: null,
      videoDuration: 0,
      captions: [],
      currentCaption: '',
      currentPlayerTime: 0,
      changeCaptionTimeout: null,
      currentTimeInterval: null,
      firstInteraction: true,
      meaningModalActive: false,
      word: {},
      itWasPlaying: false,
      displayConfig: false,
      displayCaption: false,
      fullCaption: '',
      showCaptions: true
    }
  }

  created () {
    this.$multiwatch(['activeLine'], function () {
      var item = this.$refs.itemRefs[this.activeLine]

      item.scrollIntoView({ behavior: 'smooth', block: 'center' })
    })
    /* this.$multiwatch(['currentPlayerTime'], function () {
      console.log(`currentPlayerTime = ${this.currentPlayerTime}`)
    }) */
  }

  mounted () {
    this.videoId = this.$route.params.videoId
    this.getVideoData()
  }

  buildYoutubeIframe () {
    window.onYouTubeIframeAPIReady = this.onYouTubeIframeAPIReady.bind()
    // 2. This code loads the IFrame Player API code asynchronously.
    var tag = document.createElement('script')

    tag.src = 'https://www.youtube.com/iframe_api'
    var firstScriptTag = document.getElementsByTagName('script')[0]
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
  }

  // 3. This function creates an <iframe> (and Yexpr.ouTube player)
  //    after the API code downloads.
  onYouTubeIframeAPIReady () {
    this.player = new window.YT.Player('player', {
      height: '100%',
      width: '100%',
      videoId: this.ytbId,
      // videoId: 'M7lc1UVf-VE',
      playerVars: {
        playsinline: 1,
        controls: 0,
        disablekb: 1,
        loop: 0,
        hl: 'en-us',
        enablejsapi: 1,
        iv_load_policy: 3,
        origin: process.env.VUE_APP_SERVERURL,
        rel: 0
      },
      events: {
        onReady: this.onPlayerReady,
        // onStateChange: this.onPlayerStateChange,
        onError: () => this.$buefy.dialog.confirm({
          title: 'Error',
          message: 'Youtube load video failed.',
          canCancel: false
        })
      }
    })
  }

  onPlayerReady (event) {
    this.updateCurrentTime()
  }

  setCurrentCaption () {
    var ts = this.player.getCurrentTime() * 1000

    if (ts >= this.videoDuration * 1000) {
      this.pauseVideo()
      return
    }
    var captionIdx = this.captions.findIndex((e, idx) => ts >= e.offset && ts < this.captions[idx + 1].offset)
    var caption = this.captions[captionIdx]
    if (!caption) {
      if (ts === 0 && this.captions.length > 0) {
        if (this.isPlaying) {
          if (this.changeCaptionTimeout) {
            clearTimeout(this.changeCaptionTimeout)
          }
          this.changeCaptionTimeout = setTimeout(this.setCurrentCaption, 500)
        }
      } else {
        this.currentCaption = ''
        this.line = []
        if (this.isPlaying) {
          if (this.changeCaptionTimeout) {
            clearTimeout(this.changeCaptionTimeout)
          }
          this.changeCaptionTimeout = setTimeout(this.setCurrentCaption, 500)
        }
      }
    } else {
      if (this.currentCaption !== caption.content) {
        this.logDicionario(this.line.filter(expr => expr.dicionarioId !== -1).map(expr => expr.dicionarioId))
      }
      this.currentCaption = caption.content
      this.line = []
      var expressions = caption.expressions.map(item => {
        return {
          isBtn: true,
          dicionarioId: item.dicionarioId,
          content: this.currentCaption.substring(item.idx, item.idx + item.length),
          idx: item.idx,
          length: item.length
        }
      }).sort((a, b) => a.idx - b.idx)

      for (var charIdx = 0; charIdx < this.currentCaption.length; charIdx++) {
        var item = expressions[0]
        if (item && item.idx === charIdx) {
          this.line.push(expressions.shift())
          charIdx += item.length - 1
        } else {
          var lastIdx = expressions.length > 0 ? expressions[0].idx - 1 : this.currentCaption.length - 1
          var content = this.currentCaption.substring(charIdx, lastIdx)
          if (charIdx !== lastIdx) {
            this.line.push({
              isBtn: false,
              dicionarioId: -1,
              content,
              idx: charIdx,
              length: content.length
            })
            charIdx += content.length - 1
          }
        }
      }
      if (this.isPlaying) {
        if (this.changeCaptionTimeout) {
          clearTimeout(this.changeCaptionTimeout)
        }
        // var nextOffset = this.captions[captionIdx + 1] ? this.captions[captionIdx + 1].offset : Infinity
        // console.log(`nextOffset = ${nextOffset}`)
        // console.log(`caption.offset + caption.duration = ${caption.offset + caption.duration}`)
        // var dur = caption.offset + caption.duration > nextOffset ? nextOffset : caption.duration
        // console.log(`dur = ${dur}`)
        this.changeCaptionTimeout = setTimeout(this.setCurrentCaption, /* caption.offset + caption.duration - ts */ 500)
      }
    }
  }

  monitorUserListening () {
    this.uploadLogUserListening()
    this.monitorListeningTimeInterval = setInterval(this.uploadLogUserListening, 1000)
  }

  async uploadLogUserListening () {
    try {
      var data = {
        ms: Math.floor(this.player.getCurrentTime() * 1000),
        videoId: this.videoId
      }
      await FetchWrapper.post(`${process.env.VUE_APP_SERVERURL}/saveUserVideoListeningLog`, data)
    } catch (e) {
      console.error('Could not log user listening.')
    }
  }

  setCurrentTimeTimeout () {
    this.currentTimeInterval = setInterval(this.updateCurrentTime, 1000)
  }

  updateCurrentTime () {
    this.currentPlayerTime = this.player.getCurrentTime()
  }

  setPlayerTime (val) {
    var target = Math.floor(val)
    this.player.seekTo(target, true)
    // this.setCurrentCaption()
    if (this.firstInteraction) {
      this.playVideo()
      this.firstInteraction = false
    }
  }

  formatSecs (val) {
    var d = Math.abs(val) / 60
    var mins = Math.floor(d)
    var secs = Math.floor((d - mins) * 60)
    var timerMins = mins === 0 ? '' : mins < 10 ? `0${mins}` : mins
    var timerSecs = secs < 10 ? `0${secs}` : secs
    return `${timerMins}${timerMins === '' ? '' : ':'}${timerSecs}`
  }

  playVideo () {
    this.isPlaying = true
    if (this.captions.length > 0) {
      this.setCurrentCaption()
    }
    this.monitorUserListening()
    this.setCurrentTimeTimeout()
    this.player.playVideo()
  }

  pauseVideo () {
    this.isPlaying = false
    if (this.changeCaptionTimeout) {
      clearTimeout(this.changeCaptionTimeout)
    }
    if (this.currentTimeInterval) {
      clearInterval(this.currentTimeInterval)
    }
    if (this.monitorListeningTimeInterval) {
      clearInterval(this.monitorListeningTimeInterval)
    }
    this.player.pauseVideo()
  }

  closeMeaningModal () {
    this.meaningModalActive = false
    if (this.itWasPlaying) {
      this.playVideo()
      this.itWasPlaying = false
    }
  }

  closeConfigModal () {
    this.displayConfig = false
    if (this.itWasPlaying) {
      this.playVideo()
      this.itWasPlaying = false
    }
  }

  closeCaptionModal () {
    this.displayCaption = false
    if (this.itWasPlaying) {
      this.playVideo()
      this.itWasPlaying = false
    }
  }

  openConfigModal () {
    if (this.isPlaying) {
      this.itWasPlaying = true
      this.pauseVideo()
    }
    this.displayConfig = true
  }

  openCaptionModal () {
    if (this.isPlaying) {
      this.itWasPlaying = true
      this.pauseVideo()
    }
    this.displayCaption = true
  }
  /* onPlayerStateChange (event) {
    console.log('player state changed')
    if (event.data === window.YT.PlayerState.PLAYING && !this.youtubeLoadDone) {
      // console.log('pausing video nooo')
      // this.player.pauseVideo()
      // setTimeout(this.stopVideo, 6000)
      this.youtubeLoadDone = true
    }
  } */

  getExpression (value) {
    if (this.isPlaying) {
      this.itWasPlaying = true
      this.pauseVideo()
    }
    this.getDicionario(value)
  }

  async getDicionario (dicionarioId) {
    this.isLoading = true
    try {
      this.word = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getDicionarioById/${dicionarioId}`))
      this.meaningModalActive = true
      this.isLoading = false
    } catch (e) {
      this.word = null
      this.meaningModalActive = false
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get word.',
        canCancel: false
      })
    }
  }

  async logDicionario (dicionarioIds) {
    if (dicionarioIds.length === 0) {
      return
    }
    var listen = true
    var read = this.showCaptions

    var route = ''
    if (read && listen) {
      route = 'read_and_listen_dicionarios'
    } else if (read) {
      route = 'read_dicionarios'
    } else if (listen) {
      route = 'listen_dicionarios'
    } else {
      console.error('logDicionario call must have read or listen or both of them set as true.')
      return
    }
    try {
      var data = {
        dicionarioIds
      }
      await FetchWrapper.post(`${process.env.VUE_APP_SERVERURL}/${route}`, data)
    } catch (e) {
      console.error('Could not log dicionario read&Orlisten.')
    }
  }

  async getVideoData () {
    this.isLoading = true
    try {
      this.videoData = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getVideoData/${this.videoId}`))
      this.ytbId = this.videoData.ytbId
      // this.captions = resp.captions
      this.captions = this.addDelayCaptions(this.videoData.captions)
      if (this.videoData.captions.length > 0) {
        var lastCaption = this.videoData.captions[this.videoData.captions.length - 1]
        this.videoDuration = Math.ceil((lastCaption.offset + lastCaption.duration) / 1000)
        var captions = ''
        this.captions.map((el) => { captions = captions.concat(' ' + el.content); return 0 })
        var regex = /\s{2,3}/g
        this.fullCaption = captions.replaceAll(regex, ' ')
      } else {
        this.displayCaption = false
        this.showCaptions = false
        this.videoDuration = 60 * 30
      }
      this.buildYoutubeIframe()
      this.isLoading = false
    } catch (e) {
      this.videoData = null
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get video data.',
        canCancel: false
      })
    }
  }

  fixCaptionsDurations (captions) {
    captions.map((obj, idx) => {
      var nextOffset = captions[idx + 1] ? captions[idx + 1].offset : Infinity
      if (obj.duration + obj.offset > nextOffset) {
        obj.duration = captions[idx + 1].offset - obj.offset
      }
      return obj
    })
    return captions
  }

  addDelayCaptions (captions) {
    captions.map((obj, idx) => {
      obj.offset = obj.offset - 500
      return obj
    })
    captions = captions.sort((a, b) => { return a.offset - b.offset })
    return captions.filter(e => e.content !== ' ')
  }
}
